import _classof from "../internals/classof";
var exports = {};
var classof = _classof;
var $String = String;
exports = function (argument) {
  if (classof(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
  return $String(argument);
};
export default exports;